module.exports = __webpack_public_path__ + "img/data-service.b5e3171a.svg";